import { render, staticRenderFns } from "./HighlightedReview.vue?vue&type=template&id=e2626a74&"
import script from "./HighlightedReview.vue?vue&type=script&lang=js&"
export * from "./HighlightedReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports